import JSBI from 'jsbi'

// exports for external consumption
export type BigintIsh = JSBI | number | string

export enum ChainId {
  MAINNET = 12301,
  TESTNET = 12302,
  PG_TEST = 102001,
}

export enum TradeType {
  EXACT_INPUT,
  EXACT_OUTPUT,
}

export enum Rounding {
  ROUND_DOWN,
  ROUND_HALF_UP,
  ROUND_UP,
}

export const FACTORY_ADDRESS_MAP = {
  [ChainId.MAINNET]: '0xb6248A92A38FdCF4f0924767Ff56758FaA7243EE', 
  [ChainId.TESTNET]: '0x50711b6908C5df5ba93743472F206FF56Bc6544B',
  [ChainId.PG_TEST]: '0xa82d24D880337BD0f3772559761B3a646449f954',
}

export const INIT_CODE_HASH_MAP = {
  [ChainId.MAINNET]: '0x24ec4151e7623acc06cb48845f178133da4296ed0d10c7a1670b0ed346348915',
  [ChainId.TESTNET]: '0xd335ad274694e62be12fa7f77891d765f030b9a91378389b3e68eb679b0ae9cf',
  [ChainId.PG_TEST]: '0x33f2a1982b2494603616ad93aab150dcbbaab18b7813e4ad8384dea23d1d96ef',
}

export const MINIMUM_LIQUIDITY = JSBI.BigInt(1000)

// exports for internal consumption
export const ZERO = JSBI.BigInt(0)
export const ONE = JSBI.BigInt(1)
export const TWO = JSBI.BigInt(2)
export const THREE = JSBI.BigInt(3)
export const FIVE = JSBI.BigInt(5)
export const TEN = JSBI.BigInt(10)
export const _100 = JSBI.BigInt(100)
export const FEES_NUMERATOR = JSBI.BigInt(9975)
export const FEES_DENOMINATOR = JSBI.BigInt(10000)

export enum SolidityType {
  uint8 = 'uint8',
  uint256 = 'uint256',
}

export const SOLIDITY_TYPE_MAXIMA = {
  [SolidityType.uint8]: JSBI.BigInt('0xff'),
  [SolidityType.uint256]: JSBI.BigInt('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff'),
}
